export default __webpack_public_path__ + "bigganchinta-colored.png";